import React, { Component } from 'react';
import { Input, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';

class FundListings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: '',
            data: [],
            filter: {},
            sort: '',
            sortType: 'text',
            sortAsc: true,
            headers: [
                { display: 'Name', accessors: ['fundName'], filter: true, width: 64 },
                { display: 'Type', accessors: ['fundType'], width: 16 },
                { display: 'Frequency', accessors: ['reportFrequency'], width: 20 },
                { display: 'Sector 1', accessors: ['sector'], filter: true, width: 20 },
                { display: 'Sector 2', accessors: ['sector2'], filter: true, width: 20 },
                { display: 'Benchmark 1', accessors: ['benchmark1'], filter: true, width: 20 },
                { display: 'Benchmark 2', accessors: ['benchmark2'], filter: true, width: 20 },
                { display: 'Benchmark 3', accessors: ['benchmark3'], filter: true, width: 20 },
                { display: 'Benchmark 4', accessors: ['benchmark4'], filter: true, width: 20 },
            ]
        };
    }

    componentDidMount() {
        this.props.log('FundListings.js/componentDidMount');
        this.onSubmit();
        this.props.passHeaders(this.state.headers, this.callback);
    }

    onSubmit = () => {
        this.props.log('FundListings.js/onSubmit');
        fetch('/api/reports/FundListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    callback = (headers) => {
        this.props.log('FundListings.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getCSVdata = () => {
        this.props.log('FundListings.js/getCSVdata');
        const retArr = [
            this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header) => (
                header.display
            ))
        ].concat(
            this.state.data.map(row => {
                let retArray = [];
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                    retArray[headerIndex] = row.data[header.accessors[0]];
                });
                return retArray;
            })
        );
        const styleArr = [
            this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header) => (
                { s: { font: { bold: true } } }
            ))
        ].concat(
            this.state.data.map(row => {
                let styleArray = [];
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                    styleArray[headerIndex] = null
                })
                return styleArray;
            })
        );
        this.props.passData(retArr, "fund-listings", styleArr);
    }

    onChangeFilter = (e) => {
        this.props.log('FundListings.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('FundListings.js/render');
        return (
            <>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th className={'pointer ' + header.classNames} key={headerIndex}
                                        onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc))}>
                                        {header.display}
                                        {header.accessors[0] === this.state.sort ? <span className="sortChevron">
                                            <FontAwesomeIcon icon={this.state.sortAsc ? faChevronUp : faChevronDown} />
                                        </span> : null}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ?
                                                this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.orderEntries(this.state.data, { uniqueId: this.state.sort, asc: this.state.sortAsc, type: this.state.sortType }).filter(entry => {
                                let temp = true;
                                Object.keys(this.state.filter).forEach(field => {
                                    if ((entry.data[field] != null && this.state.filter[field] != null &&
                                        (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                        ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                })
                                return temp;
                            }).map(row => (
                                <tr key={row.formEntryId}>
                                    {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                        <td key={headerIndex} className={header.classNames}>{row.data[header.accessors[0]]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    : <>No results</>}
            </>
        );

    }
}

export default FundListings;
